export default `
	guid
	available_for
	can_overlap_with_booking
	can_only_select_one_per_day
	can_book_from
	can_book_until
	can_cancel_until
	active
	
	employees {
        guid
		name
		
		department {
			name
		}
		
		team {
			name
		}
    }
    
    teams {
        guid
        name
    }

	jobtitles {
		guid
		name
	}
`;
